module.exports = __webpack_public_path__ + "assets/58a09de33f8784aa62c53e44abfd2990.mp3";